export { default } from "./ImageTopic";
